import React from 'react';
import '../animations.css';

const Background = () => {
  return (
    <div className="smileys">
      <span>😃</span>
      <span>😍</span>
      <span>😊</span>
      <span>🥳</span>
      <span>🤩</span>
      <span>😃</span>
      <span>😍</span>
      <span>😊</span>
      <span>🥳</span>
      <span>🤩</span>
    </div>
  )
};

export default Background;